import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { Customer } from 'src/app/api/customer/customer';
import { CustomerApiService } from 'src/app/api/customer/customerApiService';

@Component({
    selector: 'customer-registration-details',
    templateUrl: './customer-registration-details.component.html',
    styleUrls: ['./customer-registration-details.component.css'],
    host: {'class': 'details'},
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class CustomerRegistrationDetailsComponent implements OnInit {
    @Input() customerId: string | null | undefined = null;
    customer: Customer | null = null;
    loading: boolean = false;

    constructor(
        private customerApiService: CustomerApiService
    ) { }

    ngOnInit(): void {
        if (this.customerId == undefined || this.customerId == null || this.customerId == '')
            return;

        this.loading = true;
        this.customerApiService.getCustomer(this.customerId)
            .subscribe(x => {
                this.customer = x;
                this.loading = false;
            },
            (error) => {
                this.loading = false;
                this.customer = null;
                console.error(error);
            });
    }
}
